module.exports = __webpack_public_path__ + "img/fw.40af4f67.png";